module.exports = __webpack_public_path__ + "static/media/homepage-screenshot.c5a841f6.png";